import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { renderDataCellLots } from "./RenderDataColumnsLots";
import { renderFilterCellLots } from "./RenderFilterColumnsLots";
import { renderHeaderCell } from "./RenderHeaderColumn";
import { renderFilterCellDocs } from "./RenderFilterColumnsDocs";
import { renderDataCellDocs } from "./RenderDataColumnsDocs";
import { renderDataCellDocsAdm } from "../UtilsAdmin/AdmRenderDataColumnsDocs";
import "../Dashboard/Default/TabLots/LotsTable.css";
import { renderDataCellLotsAdm } from "../UtilsAdmin/AdmRenderDataColumnsLots";
import { renderFilterCellLotsAdm } from "../UtilsAdmin/AdmRenderFilterColumnsLots";
import { renderFilterCellDocsAdm } from "../UtilsAdmin/AdmRenderFilterColumnDocs";

// Fonction qui renvoie la ligne de nommage des colonnes
export const renderHeaderRow = (
  config,
  colorFilter,
  toggleDateFilterVisibility,
  t
) => (
  <tr className="style_thead_tr">
    {config.map((col, idx) =>
      renderHeaderCell(col, idx, colorFilter, toggleDateFilterVisibility, t)
    )}
  </tr>
);

// Fonction qui renvoie la ligne des filtres/tri
export const renderFilterRow = (config, context) => {
  if (context.tableId === "Lots") {
    return (
      <tr className="style_tbody_tr_first">
        {config.map((col, idx) => {
          if (col.admFilterType){
            return renderFilterCellLotsAdm(col, idx, context);
          } else {
            return renderFilterCellLots(col, idx, context);
          }
        })
        }
      </tr>
    );
  } else if (context.tableId === "Docs") {
    return (
      <tr className="style_tbody_tr_first">
        {config.map((col, idx) =>{
          if (col.admFilterType){
            return renderFilterCellDocsAdm(col, idx, context);
          } else {
            return renderFilterCellDocs(col, idx, context);
          }
        } 
        )}
      </tr>
    );
  }
};

// Fonction qui renvoie les lignes de data
export const renderDataRow = (item, config, context, index) => {
  const key = item.kInstanceId ?? `fallback-key-${index}`;

  if (context.tableId === "Lots") {
    return (
      <tr key={key} className="style_tbody_tr_second">
        {config.map((col, idx) => {
          if (col.admData) {
            return renderDataCellLotsAdm(item, col, context, idx)
          } else {
            return renderDataCellLots(item, col, context, idx);
          }
        })}
      </tr>
    );
  }

  if (context.tableId === "Docs") {
    return (
      <tr key={key} className="style_tbody_tr_second">
        {config.map((col, idx) => {
          if (col.admData) {
            return renderDataCellDocsAdm(item, col, context, idx);
          } else {
            return renderDataCellDocs(item, col, context, idx);
          }
        })}
      </tr>
    );
  }

  return null;
};

// Colonne de tri
export const renderSortableColumn = (context, columnKey, field) => {
  const { colorFilterAction, sortField, sortOrder, handleSort } = context;

  return (
    <th
      style={{ backgroundColor: colorFilterAction }}
      className="style_tbody_th style_sort"
      key={`sortable-${field}`}
      onClick={() => handleSort(field)}
    >
      {sortField === field && sortOrder === "asc" ? (
        <FontAwesomeIcon icon={faSortDown} />
      ) : (
        <FontAwesomeIcon icon={faSortUp} />
      )}
    </th>
  );
};

// Colonne input
export const renderSetFilterInputColumn = (
  context,
  columnKey,
  colspanValue,
  placeholderValue,
  valueData
) => {
  const { colorFilterAction, t, setFilter, filter } = context;

  const shouldUseStorage = context.tableId === "Lots";
  const localStorageKey = `filter_${valueData}`;
  const localStorageValue = shouldUseStorage
    ? localStorage.getItem(localStorageKey)
    : "";
  const inputValue = filter[valueData] ?? localStorageValue ?? "";

  const handleChange = (e) => {
    const value = e.target.value;
    setFilter({ ...filter, [valueData]: value });
    if (shouldUseStorage) {
      localStorage.setItem(localStorageKey, value);
    }
  };

  return (
    <th
      key={`input-${columnKey}`}
      className="style_tbody_th input_size"
      style={{ backgroundColor: colorFilterAction }}
      colSpan={colspanValue}
    >
      <input
        type="text"
        className="form-control placeholder-font style_input"
        placeholder={t(placeholderValue)}
        value={inputValue}
        onChange={handleChange}
      />
    </th>
  );
};

// Colonne select
export const renderSetFilterSelectColumn = (
  context,
  columnKey,
  valueData,
  valueFilterData,
  placeholderValue
) => {
  const { colorFilterAction, setFilter, filter, t } = context;

  let options = Array.isArray(valueData) ? valueData.flat() : [];

  if (typeof options[0] === "object" && options[0] !== null) {
    options = options.map(
      (item) =>
        item.id ?? item.ModelDocumentStatus ?? item.ModelInstanceStatus ?? "-"
    );
  }

  const uniqueOptions = [...new Set(options.filter(Boolean))];

  if (uniqueOptions.length === 1) {
    return (
      <th
        key={`select-${columnKey}`}
        style={{ backgroundColor: colorFilterAction, color: "white" }}
        className="style_tbody_th"
      >
        <span>{uniqueOptions[0]}</span>
      </th>
    );
  }

  const shouldUseStorage = context.tableId === "Lots";
  const localStorageKey = `filter_${valueFilterData}`;
  const localStorageValue = shouldUseStorage
    ? localStorage.getItem(localStorageKey)
    : "";
  const selectValue = filter[valueFilterData] ?? localStorageValue ?? "";

  const handleChange = (e) => {
    const value = e.target.value;
    setFilter({ ...filter, [valueFilterData]: value });
    if (shouldUseStorage) {
      localStorage.setItem(localStorageKey, value);
    }
  };

  return (
    <th
      key={`select-${columnKey}`}
      className="style_tbody_th"
      style={{ backgroundColor: colorFilterAction }}
    >
      <select
        className="form-select style_select"
        onChange={handleChange}
        value={selectValue}
      >
        <option value="">{t(placeholderValue)}</option>
        {uniqueOptions.map((result, index) => (
          <option value={result} key={`opt-${index}`}>
            {result}
          </option>
        ))}
      </select>
    </th>
  );
};
